import { cn } from "@/lib/revive-landing/utils";

const base =
  "inline-flex items-center justify-center rounded-xl text-sm font-semibold transition-colors disabled:pointer-events-none disabled:opacity-50";

const variantClass = {
  default: "bg-emerald-400 text-black hover:bg-emerald-300",
  secondary: "bg-zinc-800 text-zinc-100 hover:bg-zinc-700",
  ghost: "text-zinc-300 hover:bg-zinc-800",
};

const sizeClass = {
  default: "h-11 px-6",
  sm: "h-9 px-4 text-sm",
  lg: "h-14 px-8 text-base",
};

export function Button({ className, variant = "default", size = "default", ...props }) {
  return (
    <button
      className={cn(base, variantClass[variant] ?? variantClass.default, sizeClass[size] ?? sizeClass.default, className)}
      {...props}
    />
  );
}
